import { render } from "./EditModel2d.vue?vue&type=template&id=46b32f94&scoped=true"
const script = {}

import "./EditModel2d.vue?vue&type=style&index=0&id=46b32f94&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b32f94"]])

export default __exports__